module.exports = __webpack_public_path__ + "static/media/touch-bg.c2936a20.jpg";